var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/~/lodash/_Symbol.js
// module id = 1290
// module chunks = 4